import gql from 'graphql-tag'

const getMessages = schema => gql`query getMessages($isSpanish: Boolean!) {
    ${schema}_message__c {
        message_type__c
        name
        is_active__c
        id
        donation_center__c
        device_type__c
        redirect_url__c @skip(if: $isSpanish)
        redirect_url__c : spanish_redirect_url__c @include(if: $isSpanish)
        description__c @skip(if: $isSpanish)
        description__c : description_es_us__c @include(if: $isSpanish)
        title__c @skip(if: $isSpanish)
        title__c : spanish_title__c @include(if: $isSpanish)
        sfid
    }
  }`

export default getMessages
